import { render } from "./createTemplate.vue?vue&type=template&id=8c27ed8e&scoped=true&ts=true"
import script from "./createTemplate.vue?vue&type=script&lang=ts"
export * from "./createTemplate.vue?vue&type=script&lang=ts"

import "./createTemplate.vue?vue&type=style&index=0&id=8c27ed8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c27ed8e"]])

export default __exports__